import { Star } from "@phosphor-icons/react";

export default function DiscoverRatingStars({ value = 0, onRate, size = 16, disabled = false, testIdPrefix = "discover-rating" }) {
    return (
        <div className="inline-flex items-center gap-1" data-testid={`${testIdPrefix}-group`}>
            {[1, 2, 3, 4, 5].map((rating) => {
                const active = rating <= Math.round(value || 0);
                return (
                    <button
                        key={rating}
                        type="button"
                        onClick={() => onRate?.(rating)}
                        disabled={disabled || !onRate}
                        className="transition-transform disabled:cursor-default disabled:opacity-80"
                        data-testid={`${testIdPrefix}-${rating}`}
                        aria-label={`Rate ${rating} star${rating > 1 ? "s" : ""}`}
                    >
                        <Star size={size} weight={active ? "fill" : "regular"} color={active ? "#D4AF37" : "rgba(255,255,255,0.35)"} />
                    </button>
                );
            })}
        </div>
    );
}